/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_DomonautInputs */

const cs_enum_domonaut = /** @type {(inputs: Enum_DomonautInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Domonaut`)
};

const en_enum_domonaut = /** @type {(inputs: Enum_DomonautInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Domonaut`)
};

/**
* | output |
* | --- |
* | "Domonaut" |
*
* @param {Enum_DomonautInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_domonaut = /** @type {((inputs?: Enum_DomonautInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_DomonautInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_domonaut(inputs)
	return cs_enum_domonaut(inputs)
});